import * as actionTypes from '../actions/ActionTypes';

const initialCommonState = {
  companiesList: [],
  userData: {},
};

const SignUpReducer = (state = initialCommonState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_COMPANIES:
      return {
        ...state,
        companiesList: getComapniesByName(action.companiesArray),
      };

    case actionTypes.LOGOUT:
      return { ...initialCommonState };

    // case actionTypes.SIGNUP_REQUEST:
    // return{
    //     ...state,

    //     userData: {
    //         name: action.signUpBody.fullName,
    //         company_id: action.signUpBody.companyId
    //     }
    // }

    default:
      return state;
  }
};

function getComapniesByName(companiesArray) {
  let companyList = [];
  companiesArray.forEach(company => {
    companyList.push({ value: company.companyId, label: company.companyName });
  });
  companyList.sort(function (a, b) {
    if (a.label < b.label) {
      return -1;
    }
    if (a.label > b.label) {
      return 1;
    }
    return 0;
  });
  return companyList;
}

export default SignUpReducer;
